module.exports = __webpack_public_path__ + "media/images/member_mypage_lead_sp-1b8f12b23efa1bc967970306d64a6a4a.png";